var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98918 10.8775L3.36263 13.2165L1.07258 13.2649C0.388195 11.9956 0 10.5432 0 8.99986C0 7.50744 0.362953 6.10006 1.00631 4.86084H1.0068L3.04559 5.23462L3.9387 7.26117C3.75177 7.80613 3.64989 8.39112 3.64989 8.99986C3.64996 9.66051 3.76963 10.2935 3.98918 10.8775Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8402 7.31873C17.9436 7.86316 17.9975 8.42541 17.9975 9.00004C17.9975 9.64438 17.9297 10.2729 17.8006 10.8792C17.3625 12.9422 16.2177 14.7437 14.6319 16.0186L14.6314 16.0181L12.0634 15.887L11.7 13.6182C12.7523 13.0011 13.5747 12.0353 14.0079 10.8792H9.19531V7.31873H17.8402Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6316 16.0181L14.6321 16.0186C13.0898 17.2583 11.1305 18.0001 8.99773 18.0001C5.57031 18.0001 2.59043 16.0844 1.07031 13.2652L3.98691 10.8777C4.74695 12.9062 6.70371 14.3502 8.99773 14.3502C9.98376 14.3502 10.9075 14.0836 11.7002 13.6183L14.6316 16.0181Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7462 2.07197L11.8306 4.45894C11.0102 3.94615 10.0404 3.64992 9.0015 3.64992C6.65556 3.64992 4.6622 5.16013 3.94023 7.26131L1.0083 4.86098H1.00781C2.50568 1.97307 5.52314 0 9.0015 0C11.1852 0 13.1875 0.777867 14.7462 2.07197Z",
    fill: "#F14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.5c767e5da530c30e7292a51c62f7c370.svg";
export { ForwardRef as ReactComponent };